import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addclickablecontact',
  templateUrl: './addclickablecontact.component.html',
  styleUrls: ['./addclickablecontact.component.css']
})
export class AddclickablecontactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
